import React from 'react';
import {Button, CircularProgress} from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {toastHelper} from '../../../utils/toast-helper';
import {useExporterSimulationMutation} from '../../../modules/simulations/simulations.api';
import {exporterScenario, peutExporter} from './echangeScenarioRules';

/** « Exporter » : télécharge le JSON autoportant du scénario terminé (blob, pas d'onglet). 409 → toast. */
function BoutonExporter({simulation}) {
    const [exporter, {isLoading}] = useExporterSimulationMutation();
    if (!peutExporter(simulation)) return null;
    const lancer = async () => {
        try {
            await exporterScenario((id) => exporter(id).unwrap(), simulation);
        } catch (e) {
            toastHelper.handleError(e, e?.status === 409 ? "Le calcul n'est pas terminé : export impossible." : "L'export a échoué.");
        }
    };
    return (
        <Button variant="outlined" color="primary" onClick={lancer} disabled={isLoading}
                startIcon={isLoading ? <CircularProgress size={16} color="inherit"/> : <FileDownloadOutlinedIcon/>}
                sx={{borderRadius: 999, textTransform: 'none', fontWeight: 700}}>
            Exporter
        </Button>
    );
}

export default BoutonExporter;
